var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 7.4999C15.9999 7.63251 15.9472 7.75968 15.8535 7.85345C15.7597 7.94722 15.6325 7.9999 15.4999 7.9999H1.70692L7.85392 14.1459C7.9478 14.2398 8.00055 14.3671 8.00055 14.4999C8.00055 14.6327 7.9478 14.76 7.85392 14.8539C7.80743 14.9004 7.75224 14.9373 7.6915 14.9624C7.63076 14.9876 7.56566 15.0005 7.49992 15.0005C7.36714 15.0005 7.2398 14.9478 7.14592 14.8539L0.145917 7.8539C0.0993539 7.80745 0.062411 7.75228 0.0372045 7.69153C0.0119981 7.63079 -0.000976562 7.56567 -0.000976562 7.4999C-0.000976562 7.43413 0.0119981 7.36901 0.0372045 7.30827C0.062411 7.24752 0.0993539 7.19234 0.145917 7.1459L7.14592 0.145899C7.2398 0.0520124 7.36714 -0.000732423 7.49992 -0.000732422C7.63269 -0.000732421 7.76003 0.0520124 7.85392 0.145899C7.9478 0.239786 8.00055 0.367123 8.00055 0.499899C8.00055 0.632675 7.9478 0.760013 7.85392 0.853899L1.70692 6.9999H15.4999C15.6325 6.9999 15.7597 7.05258 15.8535 7.14635C15.9472 7.24011 15.9999 7.36729 15.9999 7.4999Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.dc0065895906debd13172fa9a080fce9.svg";
export { ForwardRef as ReactComponent };